export default {"betWrapper":"YJttS","name":"-fDtu","spreadValue":"N8yKE","subeventName":"raQo6","marketName":"_1ycA-","closeBet":"G1P-i","disabled":"lCTHq"};